import { render, staticRenderFns } from "./Type1Form.vue?vue&type=template&id=337dcf1f&scoped=true&"
import script from "./Type1Form.vue?vue&type=script&lang=js&"
export * from "./Type1Form.vue?vue&type=script&lang=js&"
import style0 from "./Type1Form.vue?vue&type=style&index=0&id=337dcf1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337dcf1f",
  null
  
)

export default component.exports